import { useDispatch } from "react-reducer-store"

const APP = {
  notification: {
    show: "NOTIFICATION_SHOW",
    hide: "NOTIFICATION_HIDE",
  },
  confirmation: {
    show: "CONFIRMATION_SHOW",
    hide: "CONFIRMATION_HIDE",
  },
  loading: true,
  appId: "APP_ID",
}

const AppActions = () => {
  const dispatch = useDispatch()

  const hideNotification = () => dispatch({ type: APP.notification.hide })

  const showNotification = message =>
    dispatch({ type: APP.notification.show, payload: message })

  const hideConfirmation = () => dispatch({ type: APP.confirmation.hide })

  const showConfirmation = message =>
    dispatch({ type: APP.confirmation.show, payload: message })

  const setLoading = payload => dispatch({ type: APP.loading }, payload)

  const setAppId = payload => dispatch({ type: APP.appId, payload })

  return {
    hideNotification,
    showNotification,
    hideConfirmation,
    showConfirmation,
    setLoading,
    setAppId,
  }
}

export { APP, AppActions }
